<!-- Navigacijska vrstica -->
<div>
  <!-- Gumb za odpiranje menija -->
  <button
    *ngIf="!navOpen"
    class="fixed top-4 left-4 z-50 p-2 bg-blue-700 text-white rounded-md shadow-lg transition hover:bg-blue-800"
    (click)="toggleNav()"
    aria-label="Odpri navigacijo"
  >
    <i class="fas fa-bars text-xl sm:text-3xl"></i>
  </button>

  <!-- Sidebar -->
  <div
    class="fixed top-0 left-0 h-full w-72 bg-white text-gray-800 shadow-2xl z-40 flex flex-col transform transition-transform duration-300 border-r-4 border-blue-600"
    [ngClass]="{ '-translate-x-full': !navOpen, 'translate-x-0': navOpen }">
    
    <div class="flex items-center justify-between px-6 py-5 border-b border-blue-700">
      <span class="font-extrabold text-2xl tracking-wide text-blue-600">MENI TARČ</span>
      <button (click)="toggleNav()" class="hover:bg-blue-100 p-2 rounded transition">
        <i class="fas fa-times text-xl text-gray-600"></i>
      </button>
    </div>
  
    <!-- Navigacijske povezave -->
    <nav class="flex flex-col gap-4 p-6">
      <a routerLink="/tarce" 
         routerLinkActive="font-bold text-blue-600"
         class="hover:text-blue-500 transition">
        <i class="fas fa-bullseye mr-2"></i> Pregled Tarč
      </a>
      
      <a routerLink="/rezultati" 
         routerLinkActive="font-bold text-blue-600"
         class="hover:text-blue-500 transition">
        <i class="fas fa-trophy mr-2"></i> Rezultati
      </a>
      
      <a routerLink="/strelci" 
         routerLinkActive="font-bold text-blue-600"
         class="hover:text-blue-500 transition">
        <i class="fas fa-users mr-2"></i> Strelci
      </a>
      
      <a routerLink="/tekme" 
         routerLinkActive="font-bold text-blue-600"
         class="hover:text-blue-500 transition">
        <i class="fas fa-calendar-alt mr-2"></i> Tekme
      </a>
      
      <a routerLink="/kategorije" 
         routerLinkActive="font-bold text-blue-600"
         class="hover:text-blue-500 transition">
        <i class="fas fa-tags mr-2"></i> Kategorije
      </a>

      <a routerLink="/klubi"
         routerLinkActive="font-bold text-blue-600"
         class="hover:text-blue-500 transition">
        <i class="fas fa-building mr-2"></i> Klubi
      </a>
    </nav>

    <!-- Nastavitve Button and Logout Button at the bottom -->
    <div class="flex flex-col mt-auto">
      <a
        routerLink="/nastavitve"
        routerLinkActive="font-bold text-green-600 dark:text-green-400"
        class="w-full text-left py-2 px-4 bg-gray-100 hover:bg-blue-100 text-blue-600 rounded transition font-semibold"
      >
        <i class="fas fa-cog mr-2"></i> Nastavitve
      </a>
      <button
        (click)="logout()"
        class="w-full text-left py-2 px-4 bg-gray-100 hover:bg-blue-100 text-blue-600 rounded transition font-semibold"
        style="outline: none; border: none;"
      >
        <i class="fas fa-sign-out-alt mr-2"></i> Odjava
      </button>
    </div>

    <!-- Footer -->
    <div class="mt-2 px-6 pb-6 text-xs text-blue-600 opacity-60">
      &copy; 2025 Tarce System. Vse pravice pridržane.
    </div>
  </div>

  <!-- Prekrivni sloj -->
  <div
    *ngIf="navOpen"
    class="fixed inset-0 bg-black bg-opacity-40 z-30"
    (click)="toggleNav()">
  </div>
</div>